import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;

  width: 100%;
  margin-top: 16px;
  padding-top: 8px;
  border-top: 1px solid #babaca;

  section {
    width: 98%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    margin: 16px 0;
    h1 {
      font-size: 22px;
    }
    p {
      font-size: 0.85rem;
    }
    .add {
      display: flex;
      align-items: center;
      justify-content: center;
      .link {
        font-size: 14px;
      }
    }
  }
`;
